import type {IssueEventInfo} from '@github-ui/dotcom-schema/types/pull_requests/v1/timeline'
import {isCopilot} from '@github-ui/assignees/copilot-user'

type ReviewEffortLevel = 'low' | 'medium' | 'high'

const REVIEW_EFFORT_LABELS: Record<ReviewEffortLevel, string> = {
  low: 'Lite',
  medium: 'Balanced',
  high: 'Max',
}

function isReviewEffortLevel(value: string | undefined): value is ReviewEffortLevel {
  return value === 'low' || value === 'medium' || value === 'high'
}

export function ReviewRequestText({info}: {info: IssueEventInfo}) {
  const {eventType, reviewerLogin, reviewerTeamSlug, reviewEffortLevel} = info
  const reviewer = reviewerLogin ?? reviewerTeamSlug
  if (!reviewer) return <>{eventType === 'review_requested' ? 'requested a review' : 'removed the review request'}</>

  const resolvedReviewEffortLevel =
    eventType === 'review_requested' &&
    reviewerLogin &&
    isCopilot(reviewerLogin) &&
    isReviewEffortLevel(reviewEffortLevel)
      ? reviewEffortLevel
      : undefined

  if (eventType === 'review_requested') {
    const reviewRequestText = resolvedReviewEffortLevel
      ? `requested a ${REVIEW_EFFORT_LABELS[resolvedReviewEffortLevel].toLowerCase()} review from `
      : 'requested a review from '

    return (
      <>
        {reviewRequestText}
        <strong>{reviewer}</strong>
      </>
    )
  }

  return (
    <>
      removed the review request for <strong>{reviewer}</strong>
    </>
  )
}
